import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './LoginPage.module.scss'
import { Card } from '@/ui/card'
import PlatformBranding from '../../components/PlatformBranding/PlatformBranding'
import DynamicForm from '../../components/DynamicForm/DynamicForm'
import { useLogin } from '../../hooks/useLogin'
import { useUIConfig } from '../../hooks/useUIConfig'
import { toast } from 'sonner'
import FormHeading from '../../components/FormHeading/FormHeading'
import { ROUTES } from '@/app/routes'

export function LoginPage() {
  const { data: uiConfig, isLoading, error } = useUIConfig()
  const loginMutation = useLogin()
  const navigate = useNavigate()
  useEffect(() => {
    if (loginMutation.isSuccess) {
      toast.success(loginMutation.data?.message ?? 'Logged in successfully')
      navigate('/dashboard')
    }

    if (loginMutation.isError) {
      const err = loginMutation.error as { response?: { data?: { message?: string } }; message?: string }
      const message = err?.response?.data?.message ?? err?.message ?? 'Login failed'

      if (message === 'Account disabled') {
        const identifier = loginMutation.variables?.identifier ?? ''
        navigate(ROUTES.OTP, { state: { identifier, fromAccountDisabled: true } })
        return
      }

      toast.error(message)
    }
  }, [loginMutation.isSuccess, loginMutation.isError, loginMutation.data, loginMutation.error, navigate, toast])

  const handleSubmit = (data: any) => {
    const identifier = data.identifier ?? data.email ?? data.username ?? ''
    const password = data.password ?? data.pass ?? ''

    loginMutation.mutate({ identifier, password })
  }

  if (isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loader}>
          <div className={styles.spinner}></div>
          <p>Loading...</p>
        </div>
      </div>
    )
  }
  if (error) return <div>Error loading config</div>

  const ui = uiConfig?.data?.ui_config

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.left}>
          <PlatformBranding
            logo={uiConfig?.data?.logo}
            platformName={ui?.platform_name}
            slogan={ui?.platform_slogan}
          />
        </div>
        <div className={styles.right}>
          <Card className={styles.form}>
            <FormHeading
              title="Sign In"
              subtitle="Enter your email & password below to login to your account"
              as="h1"
              align="center"
            />
            <DynamicForm
              fields={ui?.formFields ?? []}
              onSubmit={handleSubmit}
              loading={loginMutation.isPending}
              primaryAction={{ label: ui?.formOptions?.buttonText ?? 'Login' }}
              options={ui?.formOptions}
            />
          </Card>
        </div>
      </div>
    </div>
  )
}
